export const LANGUAGES = [
    {value: 'pl', name: 'PL'},
    {value: 'en', name: 'EN'},
];
